<template>
  <div class="addressList">
    <Address
      :value="item.address"
      :lng="item.x"
      :lat="item.y"
      :type="item.type"
      class="addressInput"
      v-for="(item, index) in list"
      :key="index"
      :readonly="readonly"
      :noUpdate="noUpdate"
      @ok="ok(item, $event)"
    >
      <a slot="btn" @click.stop="list.splice(index, 1)" v-if="readonly != true"
        >删除</a
      >
    </Address>
    <Button
      @click="$refs.selectMap.openMap()"
      type="primary"
      size="small"
      v-if="readonly != true && list.length == 0"
      >添加地址</Button
    >
    <selectMapTool
      ref="selectMap"
      :list1="list1"
      :list2="list2"
      @add="reAdd"
    ></selectMapTool>
  </div>
</template>
<script>
import selectMapTool from "./selectMapTool.vue";
export default {
  props: ["list", "list1", "list2", "readonly", "noUpdate"],
  components: { selectMapTool },
  data() {
    return {
      openList: false,
    };
  },
  methods: {
    openMap(row) {},
    ok(t, v) {

      t.address = v.name + "_" + v.address;
    },
    reAdd(v) {
      this.list.push(v);
      this.openList = false;
      this.$emit("update:list", this.list);
    },
  },
  mounted() {},
};
</script>
<style>
#selectMap {
  width: 100%;
  height: 240px;
  background: #f5f5f5;
}
#selectInput {
  width: 100%;
  height: 40px;
}
#selectMapList {
  width: 100%;
  height: calc(100% - 300px);
  overflow: auto;
}
#selectMapList li {
  padding: 10px 0;
  cursor: pointer;
}

#selectMapList li h4 {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 4px;
}
#selectMapList li h4 .ivu-tag {
  margin-right: 4px;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/addressList.vue